// src/components/AskGenie/TemplateCard.jsx
import React from 'react';
import { Calendar, DollarSign, Shield, FileText } from 'lucide-react';

function TemplateCard({ template, onClick }) {
  return (
    <div className="col">
      <button
        className={`card h-100 text-start p-3 ${template.isCompatible ? '' : 'opacity-50'} w-100`}
        onClick={onClick}
        disabled={!template.isCompatible}
        style={{ maxWidth: '500px' }}
      >
        <div className="d-flex gap-3">
          {template.icon === 'bi-calendar' && (
            <Calendar
              size={24}
              className="p-2 bg-primary bg-opacity-10 rounded text-primary"
              style={{ width: '40px', height: '40px' }}
            />
          )}
          {template.icon === 'bi-currency-dollar' && (
            <DollarSign
              size={24}
              className="p-2 bg-primary bg-opacity-10 rounded text-primary"
              style={{ width: '40px', height: '40px' }}
            />
          )}
          {template.icon === 'bi-shield-check' && (
            <Shield
              size={24}
              className="p-2 bg-primary bg-opacity-10 rounded text-primary"
              style={{ width: '40px', height: '40px' }}
            />
          )}
          {template.icon === 'bi-file-earmark-text' && (
            <FileText
              size={24}
              className="p-2 bg-primary bg-opacity-10 rounded text-primary"
              style={{ width: '40px', height: '40px' }}
            />
          )}
          <div>
            <h5 className="fw-semibold">{template.title}</h5>
            <p className="small text-muted">{template.description}</p>
            <div className="small bg-light p-2 rounded">"{template.sampleQuery}"</div>
          </div>
        </div>
      </button>
    </div>
  );
}

export default TemplateCard;